import { Injectable } from '@angular/core';
import { JwtHelperService } from '@auth0/angular-jwt';
export const TOKEN = 'gowint_token';

@Injectable({
  providedIn: 'root'
})
export class UtilsService {

  constructor(
    private jwtHelper: JwtHelperService
  ) {}

  isTokenExpired(token: string = TOKEN): boolean {
    const jwtStr = this.getToken(token);
    if (jwtStr) {
      return this.jwtHelper.isTokenExpired(jwtStr) as boolean;
    } else {
      return true;
    }
  }

  writeToken(value: string, token: string = TOKEN): void {
    localStorage.setItem(token, value);
  }

  getToken(token: string = TOKEN): any {
    return localStorage.getItem(token);
  }

  removeToken(token: string = TOKEN): void {
    if (this.getToken()) {
      localStorage.removeItem(token);
    }
  }
}
